import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "redux/hooks";

import { DIGIPOSTHEME } from "theme/digiPosTheme";

import { Typography } from "components";
import { Row } from "components/BaseComponents/Flex";
import { OtherTransactionWrapper } from "./OtherTransactions.styles";

const OtherTransactions: FC = () => {
  const { t } = useTranslation();

  const { userOtp } = useAppSelector((state) => state.otp);

  return (
    <OtherTransactionWrapper>
      <Row backgroundColor={DIGIPOSTHEME.colors.transparent} noMargin>
        <Typography margin='5px 0' size='14px' weight='500'>
          {t("otp_last_login_date")}
          {userOtp?.lastVisitDate} {userOtp?.lastVisitTime}
        </Typography>
      </Row>
      <Row backgroundColor={DIGIPOSTHEME.colors.transparent} noMargin>
        <Typography margin='5px 0' size='14px' weight='500'>
          {t("otp_last_failed_login_date")}
          {userOtp?.htlVisitDate} {userOtp?.htlVisitTime}
        </Typography>
      </Row>
    </OtherTransactionWrapper>
  );
};

export default OtherTransactions;
